import { DecimalPipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { DxDataGridComponent } from "devextreme-angular";
import { ToastrService } from "ngx-toastr";
import { map, startWith } from "rxjs/operators";
import { VendorReceiptPaymentForm } from "../../model/vendorReceiptPayment";
import { VendorReceiptPaymentDetails } from "../../model/vendorReceiptPaymentDetails";
import { CreateloadService } from "../../services/createload.service";
import { DeductionService } from "../../services/deduction.service";
import { DriversService } from "../../services/driver.service";
import { DriverinvoiceService } from "../../services/driverinvoice.service";
import { DwollacustomerService } from "../../services/dwollacustomer.service";
import { ReceiptPaymentService } from "../../services/receiptpayment.service";
import { SetupDataService } from "../../services/setupdata.service";
import { DwollapaymentpopupComponent } from "../e-banking/dwollapaymentpopup/dwollapaymentpopup.component";
import { getCurrency, toPascalCase } from "../../common/commonHelper";
import { tableHeaderCustomStyle } from "../../config/pdfStyle";
import { GeneratePdfComponent } from "../shared/generate-pdf/generate-pdf.component";
import { CompanyService } from "../../services/company.service";
import { CarrierinvoiceService } from "../../services/carrierinvoice.service";
import { DropoffserviceService } from "../../services/dropoffservice.service";
import { CarrierService } from "../../services/carrier.service";

@Component({
  selector: 'app-loads-pay-popup-payment-component',
  templateUrl: './loads-pay-popup-payment-component.component.html',
  styleUrls: ['./loads-pay-popup-payment-component.component.scss'],
  providers: [
    ToastrService,
    DriversService,
    DriverinvoiceService,
    SetupDataService,
    DwollacustomerService,
    MatDialog,
    CarrierService
  ],
})
export class LoadsPayPopupPaymentComponentComponent implements OnInit {
  @Input() loadNumber: number;
  @Input() role: string = 'driver';
  @Input() driverpayInvoiceStatus: string;
  @Input() pickupInfo: any;
  @Output() newItemEvent = new EventEmitter<string>();
  constructor(
    private formBuilder: UntypedFormBuilder,
    private _driverService: DriversService,
    private _carrierService: CarrierService,
    private _loadservice: CreateloadService,
    private _driverinvoiceservice: DriverinvoiceService,
    private _carrierinvoiceservice: CarrierinvoiceService,
    private _receiptpaymentservice: ReceiptPaymentService,
    private _toaster: ToastrService,
    private router: Router,
    private _setupDataSetvice: SetupDataService,
    private _dwollaCustomerService: DwollacustomerService,
    public dialog: MatDialog,
    private decimalPipe: DecimalPipe,
    private _deductionservice: DeductionService,
    private _dropOffService: DropoffserviceService,
    public companyService: CompanyService,
    private _makePdfService: GeneratePdfComponent
  ) { }
  searchForm: UntypedFormGroup;
  vendorReceiptPayment = {} as VendorReceiptPaymentForm;
  vendorReceiptPaymentDetail = {} as VendorReceiptPaymentDetails;
  loadstatusDetails: any = [];
  isDataLoading = false;
  selectedDriverInvoices: any[] = [];
  paymentDate;
  companyData: any[] = [];
  driverdata = [];
  carrierdata = [];
  filteredDrivers;
  filteredCarriers;
  carrierNameIdMap = {};
  driverNameIdMap = {};
  loadDetailsGrid: any;
  paymentHistoryData: any;
  loadingVisible = false;
  totalBill = 0;
  totalAmount = 0;
  loadInitialData;
  StatusList;
  SearchedData: any;
  paymentMethods: any[] = [];
  bankList: any[] = [];
  dwollaCustomerData: any[] = [];
  receiverDwollaCUstomerData;
  senderDwollaCUstomerData;
  isDwollaCustomer = false;
  receiverFundingSourceId = "";
  senderFundingSourceId = "";
  senderFundingSourceName = "";
  recieverFundingSourceName = "";
  isACH = false;
  isCash = false;
  deductions: any[] = [];
  deductionsConst: any[] = [];
  paymentHistoryDeductions: any[] = [];
  dropOffData: any[] = [];
  selfToPascalCase = toPascalCase;
  getCurrency = getCurrency;

  ngOnInit() {
    this.getCompantData();
    var date = new Date();
    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth() + 1).toString();
    var dd = date.getDate().toString();
    this.paymentDate =
      yyyy +
      "-" +
      (mm[1] ? mm : "0" + mm[0]) +
      "-" +
      (dd[1] ? dd : "0" + dd[0]);
    this.loadstatusDetails = this._loadservice.getLoadStatusList("Invoice");
    this.searchFormBuild();
    this.getDriverData();
    this.getCarrierData()
    this.getDropOffData();
    this.getData();
    this.getPaymentMethods();
    this.getBankAccounts();
    this.getDeductionData();
    this._dwollaCustomerService.getDwollaAllCustomerData().subscribe((data) => {
      this.dwollaCustomerData = data.result;
    });
  }
  private getPaymentMethods() {
    this._setupDataSetvice.getBCPaymentMethods().subscribe((data) => {
      this.paymentMethods = data.result;
    });
  }
  private getBankAccounts() {
    this._setupDataSetvice.getBCBanks().subscribe((data) => {
      this.bankList = data.result;
    });
  }

  getDeductionData() {
    this._deductionservice.getDeductionData(this.role).subscribe((data) => {
      for (let i = 0; i < data.result.length; i++) {
        let deduction = data.result[i];
        let tempDeduction = data.result[i]
        deduction = deduction?.billLines?.filter((x: any) => x.loadId?.loadNumber === this.loadNumber)
        for (let j = 0; j < deduction?.length; j++) {
          const deductionLine = deduction[j];
          let deductionObj = {
            dueDate: tempDeduction.dueDate,
            billId: tempDeduction.billId,
            loadNumber: deductionLine?.loadId?.loadNumber,
            loadId: deductionLine?.loadId?._id,
            driverId: deductionLine?.driverId?._id,
            carrierId:data.result[i]?.carrierId,
            truckId: deductionLine?.truckId,
            trailerId: deductionLine?.trailerId,
            billAmount: deductionLine.billAmount * -1,
            comment: deductionLine.comment,
            deliveryDate: deduction.dueDate,
            finalAmount: deductionLine.billAmount * -1,
            remainingAmount:
              (deductionLine.billAmount - deductionLine.paidAmount) * -1,
            paymentAmount: "",
            isEdited: false,
            isDeduction: true,
            expense: deductionLine.expenseType,
            deductionId: deductionLine._id,
            driverName: this.role === 'carrier' ? data.result[i]?.carrierName : deduction?.driverName || deductionLine?.driverId?.fullName,
            carrierName: data.result[i]?.carrierName,
            _id: deductionLine._id
          };
          if (deductionLine?.remainingAmount > 0) {
            this.deductions.push(deductionObj);
            this.deductionsConst.push(deductionObj);
          }
          if (deductionLine?.paidAmount > 0) {
            this.paymentHistoryDeductions.push(deductionObj);
          }
        }
      }
      console.log('Deduction list', this.deductions);
    });
  }

  getDropOffData() {
    this._dropOffService.getdroppoffData().subscribe((data) => {
      this.dropOffData = data.result;
    })
  }

  searchFormBuild() {
    let driverId = this.pickupInfo?.driver1?._id || this.pickupInfo?.driver2?._id;
    let driverName = this.pickupInfo?.driver1?.fullName || this.pickupInfo?.driver2?.fullName;
    let carrierId = this.pickupInfo?.carrier?._id;
    let carrierName = this.pickupInfo?.carrier?.companyname;
    this.searchForm = this.formBuilder.group(
      {
        carrier: [carrierName || "All"],
        driver: [driverName || "All"],
        driverId: [driverId || ""],
        carrierId: [carrierId || ""],
        date: [this.paymentDate],
        paymentMethod: [""],
        bankAccount: [""],
        paymentReference: [""],
        balance: [""],
        amount: [""],
      },
      {}
    );
  }

  getData() {
    this.StatusList = this._loadservice.getLoadStatusList("");
    if (this.role === 'driver') {
      this._driverinvoiceservice.getLoadsForDriverPay().subscribe((data) => {
        // Filter Data by Load Number
        data.result = data.result.filter((x: any) => x.loadNumber === this.loadNumber);
        // Filter driverData if driver exists in result as driverId
        const driverData = this.driverdata.filter(driver => data.result.find((x: any) => x.driverId === driver._id));
        this.driverdata = driverData;
        this.filteredDrivers = this.searchForm.get("driver")!.valueChanges.pipe(
          startWith(""),
          map((value) => this._filter(value))
        );
        this.loadInitialData = [];
        for (let i = 0; i < data.result?.length; i++) {
          let item = data.result[i];
          const deliveryAddress = this.dropOffData?.find(dropOff => dropOff.loadId?._id === item.loadId)?.dropAddress?.fullAddress;
          item.deliveryAddress = deliveryAddress;
          this.loadInitialData.push(item);
        }
        // this.loadInitialData = data.result;
        let newLoadData = this.loadInitialData;
        if(this.searchForm.get("driverId").value != '') {
          newLoadData = this.loadInitialData.filter((driver) => driver.driverId === this.searchForm.get("driverId").value);
          this.deductions = this.deductionsConst.filter(
            (deduction) => deduction?.driverId == this.searchForm.get("driverId").value
          );
        }
        this.getLoadGrid(newLoadData);
        this.getPaymentHistoryData(newLoadData);
      });
    } else if (this.role === 'carrier') {
      this._carrierinvoiceservice.getLoadsForCarrierPay().subscribe((data) => {
        data.result = data.result.filter((x: any) => x.loadNumber === this.loadNumber);
        const carrierData = this.carrierdata.filter(carrier => data.result.find((x: any) => x.carrierId === carrier._id));

        this.carrierdata = carrierData;
        this.filteredCarriers = this.searchForm.get("carrier")!.valueChanges.pipe(
          startWith(""),
          map((value) => this._filterCarrier(value))
        );
        console.log('Filtered carrier data', this.filteredCarriers);

        this.loadInitialData = [];
        for (let i = 0; i < data.result?.length; i++) {
          let item = data.result[i];
          const deliveryAddress = this.dropOffData?.find(dropOff => dropOff.loadId?._id === item.loadId)?.dropAddress?.fullAddress;
          item.deliveryAddress = deliveryAddress;
          this.loadInitialData.push(item);
        }
        let newLoadData = this.loadInitialData;
        if(this.searchForm.get("carrierId").value != '') {
          newLoadData = this.loadInitialData.filter((carrier) => carrier.carrierId === this.searchForm.get("carrierId").value);
          this.deductions = this.deductionsConst.filter(
            (deduction) => deduction?.carrierId == this.searchForm.get("carrierId").value
          );
        }
        this.getLoadGrid(newLoadData);
        this.getPaymentHistoryData(newLoadData);
      });
    }
  }


  getCarrierData() {
    this.carrierdata = [];
    this._carrierService.getCarrierData().subscribe((data) => {
      for (var i = 0; i < data.result.length; i++) {
        if (data.result[i].companyname != undefined) {
          this.carrierdata.push(data.result[i]);
          this.carrierNameIdMap[data.result[i].companyname] =
            data.result[i]._id;
        }
      }
    });
    this.filteredCarriers = this.searchForm.get("carrier")!.valueChanges.pipe(
      startWith(""),
      map((value) => this._filterCarrier(value))
    );
    console.log('filtered carrier data', this.filteredCarriers)
  }

  getDriverData() {
    this.driverdata = [];
    this._driverService.getDriversData().subscribe((data) => {
      for (var i = 0; i < data.result.length; i++) {
        if (data.result[i].fullName != undefined) {
          this.driverdata.push(data.result[i]);
          this.driverNameIdMap[data.result[i].fullName] = data.result[i]._id;
        }
      }
    });
    this.filteredDrivers = this.searchForm.get("driver")!.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value))
    );
  }
  filterData(event) {
    this.SearchedData = this.loadDetailsGrid.filter(function (e) {
      return e.loadNumbers
        .toString()
        .toLowerCase()
        .includes(event.toString().toLowerCase());
    });
  }
  private _filter(value: string): string[] {
    if (value != "") {
      const filterValue = value.toLowerCase().replace(/[\W_]/g, "");
      return this.driverdata.filter((option) =>
        option.fullName
          .toLowerCase()
          .replace(/[\W_]/g, "")
          .includes(filterValue)
      );
    } else {
      this.searchForm.get("driverId").setValue("");
      return this.driverdata;
    }
  }

  private _filterCarrier(value: string): string[] {
    if (value != "" && value != undefined) {
      const filterValue = value.toLowerCase().replace(/[\W_]/g, "");
      return this.carrierdata.filter((option) =>
        option.companyname.toLowerCase().replace(/[\W_]/g, "").includes(filterValue)
      );
    } else {
      this.searchForm.get("carrierId").setValue("");
      return this.carrierdata;
    }
  }

  getLoadGrid(loads) {
    const loadsCompleteData = loads.filter(
      (x) => x.invoiceStatus == "completed"
    );
    const loadsData = loadsCompleteData.filter(
      (x) =>
        Math.round(
          x.invoiceLineItems[0].lineItemAmount -
          x.invoiceLineItems[0].paidAmount -
          x.invoiceLineItems[0]?.deductionAmount
        ) > 0
    );
    this.loadDetailsGrid = loadsData;
    let bal: number = 0;
    loadsData.forEach(
      (a) => (bal += a.invoiceLineItems[0].lineItemAmount.toFixed(2))
    );
    // this.rAmount = Number(event.target.value) + Number(this.rAmount);
    this.searchForm.patchValue({ balance: bal });
    if (this.loadDetailsGrid.length > 0) {
      for (var i = 0; i < this.loadDetailsGrid.length; i++) {
        this.loadDetailsGrid[i]["isEdited"] = false;
        this.loadDetailsGrid[i]["isDeduction"] = false;
        this.loadDetailsGrid[i]["paymentAmount"] = "";
        this.loadDetailsGrid[i]["billId"] =
          this.loadDetailsGrid[i].invoiceLineItems[0].invoiceId.invoiceId;
        this.loadDetailsGrid[i]["remainingAmount"] =
          this.loadDetailsGrid[i]["invoiceLineItems"][0]["lineItemAmount"] -
          this.loadDetailsGrid[i]["invoiceLineItems"][0]["paidAmount"] -
          this.loadDetailsGrid[i]["invoiceLineItems"][0]["deductionAmount"];
        this.loadDetailsGrid[i]["finalAmount"] =
          this.loadDetailsGrid[i]["invoiceLineItems"][0]["lineItemAmount"];
        const dwollaCustomer = this.dwollaCustomerData.find(
          (dc) => dc.customerId === this.loadDetailsGrid[i]["driverId"]
        );
        this.receiverDwollaCUstomerData = dwollaCustomer;
        dwollaCustomer != undefined
          ? (this.loadDetailsGrid[i]["isDwollaCustomer"] = true)
          : (this.loadDetailsGrid[i]["isDwollaCustomer"] = false);
        dwollaCustomer != undefined
          ? (this.loadDetailsGrid[i]["dwollaCustomerId"] =
            dwollaCustomer.dwollaCustomerId)
          : (this.loadDetailsGrid[i]["dwollaCustomerId"] = "");
        this.isDwollaCustomer = dwollaCustomer != undefined ? true : false;
      }
    }
    for (let j = 0; j < this.deductions.length; j++) {
      const deduction = this.deductions[j];
      // deduction.driverName = this.searchForm.controls.driver.value == 'All' ? '-' : this.searchForm.controls.driver.value;
      this.loadDetailsGrid.push(deduction);
    }
    this.SearchedData = this.loadDetailsGrid;
  }


  getPaymentHistoryData(loads) {
    loads = loads.filter((x) => x.invoiceList?.length > 0);
    this.paymentHistoryData = loads;
    let bal: number = 0;
    loads.forEach(
      (a) => (bal += a.invoiceLineItems[0].lineItemAmount.toFixed(2))
    );
    // this.rAmount = Number(event.target.value) + Number(this.rAmount);
    this.searchForm.patchValue({ balance: bal });
    if (this.paymentHistoryData.length > 0) {
      for (var i = 0; i < this.paymentHistoryData.length; i++) {
        this.paymentHistoryData[i]["isEdited"] = false;
        this.paymentHistoryData[i]["isDeduction"] = false;
        this.paymentHistoryData[i]["paymentAmount"] = "";
        this.paymentHistoryData[i]["billId"] =
          this.paymentHistoryData[i].invoiceLineItems[0].invoiceId.invoiceId;
        this.paymentHistoryData[i]["remainingAmount"] =
          this.paymentHistoryData[i]["invoiceLineItems"][0]["lineItemAmount"] -
          this.paymentHistoryData[i]["invoiceLineItems"][0]["paidAmount"] -
          this.paymentHistoryData[i]["invoiceLineItems"][0]["deductionAmount"];
        this.paymentHistoryData[i]["finalAmount"] =
          this.paymentHistoryData[i]["invoiceLineItems"][0]["lineItemAmount"];
        const dwollaCustomer = this.dwollaCustomerData.find(
          (dc) => dc.customerId === this.paymentHistoryData[i]["driverId"]
        );
        this.receiverDwollaCUstomerData = dwollaCustomer;
        dwollaCustomer != undefined
          ? (this.paymentHistoryData[i]["isDwollaCustomer"] = true)
          : (this.paymentHistoryData[i]["isDwollaCustomer"] = false);
        dwollaCustomer != undefined
          ? (this.paymentHistoryData[i]["dwollaCustomerId"] =
            dwollaCustomer.dwollaCustomerId)
          : (this.paymentHistoryData[i]["dwollaCustomerId"] = "");
        this.isDwollaCustomer = dwollaCustomer != undefined ? true : false;
      }
    }
    for (let j = 0; j < this.paymentHistoryDeductions.length; j++) {
      const deduction = this.paymentHistoryDeductions[j];
      this.paymentHistoryData.push(deduction);
    }
    // this.SearchedData = this.paymentHistoryData;
  }

  prepareDeductionData() {

  }
  isDriverSelected = false;
  onDriverSelected(driverName) {
    if (driverName != "") {
      if (driverName == "All") {
        this.getData();
        this.deductions = this.deductionsConst;
      } else {
        this.searchForm
          .get("driverId")
          .setValue(this.driverNameIdMap[driverName]);
        console.log(this.searchForm.value);
        let filteredLoadData = this.loadInitialData;
        let searchOptions = this.searchForm.value;
        filteredLoadData = filteredLoadData.filter(
          (x) => x.driverId == searchOptions.driverId
        );
        this.deductions = this.deductionsConst.filter(
          (deduction) => deduction?.driverId == searchOptions.driverId
        );
        this.getLoadGrid(filteredLoadData);
        this.getPaymentHistoryData(filteredLoadData);
      }
    }
  }


  onCarrierSelected(carrier) {
    let carrierName = carrier.fullName;
    if (carrierName != "") {
      if (carrierName == "All") {
        this.getData();
        this.deductions = this.deductionsConst;
      } else {
        this.searchForm
          .get("carrierId")
          .setValue(this.carrierNameIdMap[carrierName]);
        let searchOptions = this.searchForm.value;
        let filteredLoadData = this.loadInitialData;
        filteredLoadData = filteredLoadData.filter(
          (x) => x.carrierId == searchOptions.carrierId
        );
        this.deductions = this.deductionsConst.filter((deduction) => deduction?.carrierId == searchOptions.carrierId);

        let newLoadData = this.loadInitialData.filter((carrier) => carrier._id === carrier._id)
        this.searchForm.patchValue({ carrier: carrier.fullName, carrierId: carrier._id })
        this.getLoadGrid(newLoadData);
        this.getPaymentHistoryData(newLoadData);
      }

    }
  }
  onAmountChange(event: any) {
    this.searchForm.patchValue({ amount: event.target.value });
  }
  formatThousandSeperator(inputNumber) {
    return this.decimalPipe.transform(inputNumber, "1.2-2");
  }
  convertNumber(inputValue) {
    inputValue = inputValue.toString();
    return Number(inputValue.replaceAll(",", ""));
  }
  onPaymentChange(event, invoiceRow) {
    if (invoiceRow.data.isDeduction) {
      if (event.target.value > 0) {
        if (
          Number(event.target.value) >
          invoiceRow.data["remainingAmount"] * -1
        ) {
          event.target.value = Number(invoiceRow.data["remainingAmount"]);
          this.paymentCal(invoiceRow, invoiceRow.data["remainingAmount"]);
        } else {
          event.target.value = event.target.value * -1;
          this.paymentCal(invoiceRow, event.target.value);
        }
      } else {
        event.target.value = event.target.value * -1;
        this.paymentCal(invoiceRow, event.target.value);
      }
    } else {
      console.log("value are", Number(event.target.value));
      if (Number(event.target.value) < 0) {
        event.target.value = Number(event.target.value) * -1;
      }
      if (Number(event.target.value) > invoiceRow.data["remainingAmount"]) {
        event.target.value = invoiceRow.data["remainingAmount"];
        this.paymentCal(invoiceRow, invoiceRow.data["remainingAmount"]);
      } else {
        this.paymentCal(invoiceRow, event.target.value);
      }
    }
  }
  paymentCal(invoiceRow, payAmount) {
    invoiceRow.data["paymentAmount"] = this.formatThousandSeperator(payAmount);
    let sum: number = 0;
    let deduction: number = 0;
    /* this.loadDetailsGrid.forEach(
      (a) => (sum += this.convertNumber(a.paymentAmount))
    ); */
    let activeInvoice = this.loadDetailsGrid.filter(
      (item) =>
        item.isDeduction == false && this.convertNumber(item.paymentAmount) > 0
    );
    let noOfInvoice = activeInvoice.length;
    this.loadDetailsGrid.forEach((a) =>
      a.isDeduction
        ? (deduction += this.convertNumber(a.paymentAmount))
        : (sum += this.convertNumber(a.paymentAmount))
    );
    this.searchForm.patchValue({
      amount: this.formatThousandSeperator(sum + deduction),
    });
    this.totalAmount = sum;
  }
  selectedRows = [];
  @ViewChild(DxDataGridComponent, { static: true })
  dataGrid: DxDataGridComponent;
  selectionChanged(e, d) {
    if (this.SearchedData[d.loadIndex]["isEdited"] == true) {
      this.dataGrid.instance.deselectRows([d.key]);
      this.SearchedData[d.loadIndex]["isEdited"] = false;
      this.getSelectedDriverInvoice();
      this.paymentCal(d, 0);
    } else {
      this.dataGrid.instance.selectRows([d.key], true);
      this.SearchedData[d.loadIndex]["isEdited"] = true;
      this.loadDetailsGrid[d.loadIndex]["paymentAmount"] =
        this.loadDetailsGrid[d.loadIndex]["remainingAmount"].toFixed(2);
      this.getSelectedDriverInvoice();
      this.paymentCal(
        d,
        this.loadDetailsGrid[d.loadIndex]["remainingAmount"].toFixed(2)
      );
    }
  }

  onSearch() {
  }
  onReset() {
    // this.searchForm.reset();
    // this.getData();
  }
  onSubmit(isValid) {
    if (isValid) {
      this.selectedDriverInvoices = this.SearchedData.filter(
        (d) => d.isEdited == true
      );
      let driverInvoice = this.selectedDriverInvoices.filter(
        (di) => di.isDeduction == false
      );
      if (this.selectedDriverInvoices.length === 0) {
        this._toaster.error(
          "Please Input Payment in Payment Lines",
          "Validation Error",
          { timeOut: 4000 }
        );
        return;
      } else if (driverInvoice.length === 0) {
        this._toaster.error(
          "Please Select at least one invoice",
          "Validation Error",
          { timeOut: 4000 }
        );
        return;
      } else if (
        this.convertNumber(this.searchForm.controls.balance.value) <
        this.convertNumber(this.searchForm.controls.amount.value)
      ) {
        this._toaster.error(
          "Payment amount can not getter than total amount",
          "Failed",
          { timeOut: 4000 }
        );
      } else {
        let isCalculateAmount = false;
        let deductionInvoice = this.selectedDriverInvoices.filter(
          (di) => di.isDeduction == true
        );
        let deductionAmount = deductionInvoice.reduce(
          (accumulator, currentValue) =>
            accumulator +
            Number(this.convertNumber(currentValue.paymentAmount)),
          0
        );
        const billIds = [];
        for (let i = 0; i < driverInvoice.length; i++) {
          const element = driverInvoice[i];
          /* let totalAmount =
            Number(this.convertNumber(element.paymentAmount)) + deductionAmount;
          if (totalAmount > Number(element.remainingAmount.toFixed(2))) {
            isCalculateAmount = true;
          } */
          if (
            Number((deductionAmount * -1).toFixed(2)) >
            Number(element.remainingAmount.toFixed(2))
          ) {
            isCalculateAmount = true;
            billIds.push(element.billId);
          }
        }
        let invoiceIds = billIds.map(billId => billId).join(', ');
        if (isCalculateAmount) {
          this._toaster.error(
            `Selected Driver Invoice ${invoiceIds} Remaining Amount should be greater than the deduction amount`,
            "Failed",
            { timeOut: 4000 }
          );
          return;
        }
        if (this.isACH) {
          if (this.isDwollaCustomer) {
            this.senderDwollaCUstomerData = this.dwollaCustomerData.find(
              (c) => c.customerId == localStorage.getItem("userId")
            );
            if (this.senderDwollaCUstomerData != undefined) {
              let dialogConfig = Object.assign(
                { width: "400px" },
                {
                  data: {
                    senderDwollaCustomerId:
                      this.senderDwollaCUstomerData.dwollaCustomerId,
                    receiverDwollaCustomerId:
                      this.receiverDwollaCUstomerData.dwollaCustomerId,
                    amount: this.searchForm.value.amount,
                  },
                },
                { disableClose: true }
              );
              let editDialogRef = this.dialog.open(
                DwollapaymentpopupComponent,
                dialogConfig
              );
              editDialogRef.afterClosed().subscribe((data) => {
                if (data == null) {
                  // this.getData();
                } else {
                  //  this.getData();
                  console.log(data);
                  this.senderFundingSourceId = data.senderFundingSourceId;
                  this.senderFundingSourceName = data.senderFundingSourceName;
                  this.receiverFundingSourceId = data.receiverFundingSourceId;
                  this.recieverFundingSourceName =
                    data.recieverFundingSourceName;
                  this.makePayment();
                }
              });
            } else {
              this._toaster.error(
                "The Sender Is Not Payment Registered, Payment Registration Required For ACH Payments",
                "Failed",
                { timeOut: 4000 }
              );
              return;
            }
          } else {
            this._toaster.error(
              "The Receiver Is Not Payment Registered, Payment Registration Required For ACH Payments",
              "Failed",
              { timeOut: 4000 }
            );
            return;
          }
        } else {
          this.makePayment();
        }
      }
    } else {
      this._toaster.error("Please enter all required filled", "Failed", {
        timeOut: 4000,
      });
    }
  }
  /* private makePayment() {
    const paymentLine = [];
    this.selectedDriverInvoices.map((p) => {
      let payment = {
        invoiceId: p.invoiceList[0],
        loadId: p.loadId,
        loadNumber: p.loadNumber,
        deliveryDate: p.deliveryDate,
        paymentAmount: this.convertNumber(p.paymentAmount).toFixed(2),
        invoiceAmount: Number(p.invoiceLineItems[0].lineItemAmount).toFixed(2),
        remainingAmount: Number(p.remainingAmount).toFixed(2),
        lineItemId: p.invoiceLineItems[0].lineItemId,
      };
      paymentLine.push(payment);
    });
    const DwollaPaymentLine = [];
    this.selectedDriverInvoices.map((p) => {
      let dwPayment = {
        invoiceId: p.invoiceList[0],
        loadNumber: p.loadNumber,
        amount: this.convertNumber(p.paymentAmount).toFixed(2),
        loadPrice: Number(p.invoiceLineItems[0].lineItemAmount).toFixed(2),
        remainingAmount: Number(p.remainingAmount).toFixed(2),
        lineItemId: p.invoiceLineItems[0].lineItemId,
      };
      DwollaPaymentLine.push(dwPayment);
    });
    let driverPayment = {
      driverId: this.searchForm.controls.driverId.value,
      driverName: this.searchForm.controls.driver.value,
      paymentDate: this.searchForm.controls.date.value,
      paymentMethod: this.searchForm.controls.paymentMethod.value,
      bankAccount: this.searchForm.controls.bankAccount.value,
      paymentRef: this.searchForm.controls.paymentReference.value,
      amount: this.convertNumber(this.searchForm.controls.amount.value).toFixed(2),
      paymentLine: paymentLine,
    };
    this.vendorReceiptPayment.Id = 0;
    this.vendorReceiptPayment.Amount = this.convertNumber(
      this.searchForm.controls.amount.value
    );
    this.vendorReceiptPayment.VendorPaymentType = "Driver Pay";
    this.vendorReceiptPayment.BankAccountNo = this.searchForm.value.bankAccount;
    this.vendorReceiptPayment.PaymentDate = this.searchForm.controls.date.value;
    if(this.searchForm.value.paymentMethod == "ACH"){
      this.vendorReceiptPayment.SenderName = this.senderDwollaCUstomerData.firstName + " " + this.senderDwollaCUstomerData.lastName ;
      this.vendorReceiptPayment.SenderFundingSource = this.senderFundingSourceId;
      this.vendorReceiptPayment.SenderFundingSourceName = this.senderFundingSourceName;
      this.vendorReceiptPayment.RecieverFundingSource = this.receiverFundingSourceId;
      this.vendorReceiptPayment.RecieverFundingSourceName = this.recieverFundingSourceName;
    }
    this.vendorReceiptPayment.PaymentLogDetail = [];
    let count = 0;
    this.SearchedData.forEach(
      function (value) {
        if (this.convertNumber(value.paymentAmount) > 0) {
          count++;
          this.vendorReceiptPaymentDetail.No = 0;
          this.vendorReceiptPaymentDetail.PaymentLogNo = 0;
          this.vendorReceiptPaymentDetail.VendorNo =
            this.searchForm.value.driverId;
          this.vendorReceiptPaymentDetail.InvoiceNo = value.invoiceList[0];
          this.vendorReceiptPaymentDetail.PaymentMethodCode =
            this.searchForm.value.paymentMethod;
          this.vendorReceiptPaymentDetail.Payment = this.convertNumber(
            value.paymentAmount
          );
          this.vendorReceiptPayment.PaymentLogDetail.push(
            this.vendorReceiptPaymentDetail
          );
        }
      }.bind(this)
    );

    this.vendorReceiptPayment.TotalInvoicePayment = count;
    let dwollaPayment = {};
    if (this.searchForm.value.paymentMethod === "ACH") {
      dwollaPayment = {
        senderCustomer: this.senderDwollaCUstomerData._id,
        senderFundingSourceId: this.senderFundingSourceId,
        receiverCustomer: this.receiverDwollaCUstomerData._id,
        receiverFundingSourceId: this.receiverFundingSourceId,
        amount: this.convertNumber(this.searchForm.controls.amount.value),
        paymentMethod: this.searchForm.controls.paymentMethod.value,
        bankAccount: this.searchForm.controls.bankAccount.value,
        paymentDate: this.searchForm.controls.date.value,
        paymentReference: this.searchForm.controls.paymentReference.value,
        lineItem: DwollaPaymentLine,
      };
    }
    const driverPaymentData = [
      driverPayment,
      this.vendorReceiptPayment,
      dwollaPayment,
    ];
    this.loadingVisible = true;
    this._driverinvoiceservice.createDriverPayment(driverPaymentData).subscribe(
      (response) => {
        this.loadingVisible = false;
        console.log(response);
        if (response.Status == "error") {
          this._toaster.error("error", "Error", { timeOut: 4000 });
          this.loadingVisible = false;
        } else {
          this._toaster.success("Save", "Success", { timeOut: 3000 });
          this.router.navigateByUrl("/loadpay/payment-history");
        }
      },
      (error) => {
        this.loadingVisible = false;
        let resError = JSON.parse(error._body);
        this._toaster.error(resError.error, "Error", {
          timeOut: 5000,
        });
      }
    );
  } */

  private makePayment() {
    let driverInvoice = this.selectedDriverInvoices.filter(
      (di) => di.isDeduction == false
    );
    let deductionInvoice = this.selectedDriverInvoices.filter(
      (di) => di.isDeduction == true
    );
    let deductionAmount = deductionInvoice.reduce(
      (accumulator, currentValue) =>
        accumulator + Number(this.convertNumber(currentValue.paymentAmount)),
      0
    );
    deductionAmount = deductionAmount * -1;
    const paymentLine = [];
    driverInvoice.map((p) => {
      let paymentAmount = 0;
      let lineDeductionAmount = 0;
      if (deductionAmount > 0) {
        if (deductionAmount > this.convertNumber(p.paymentAmount)) {
          let indexNumber = driverInvoice.indexOf(p);
          if (indexNumber == driverInvoice.length - 1) {
            lineDeductionAmount = deductionAmount;
            paymentAmount = 0;
            deductionAmount = 0;
          } else {
            lineDeductionAmount = this.convertNumber(p.paymentAmount);
            paymentAmount = 0;
            deductionAmount =
              deductionAmount - this.convertNumber(p.paymentAmount);
          }
        } else {
          paymentAmount = this.convertNumber(p.paymentAmount) - deductionAmount;
          lineDeductionAmount = deductionAmount;
          deductionAmount = 0;
        }
      } else if (deductionAmount == 0) {
        paymentAmount = this.convertNumber(p.paymentAmount);
        lineDeductionAmount = 0;
        deductionAmount = 0;
      }
      let payment = {
        invoiceId: p.billId,
        loadId: p.loadId,
        loadNumber: p.loadNumber,
        deliveryDate: p.deliveryDate,
        paymentAmount: paymentAmount.toFixed(2),
        invoiceAmount: Number(p.finalAmount).toFixed(2),
        remainingAmount: Number(p.remainingAmount).toFixed(2),
        lineItemId: p.invoiceLineItems ? p.invoiceLineItems[0]?.lineItemId : "",
        expense: p.expense ? p.expense : null,
        isDeduction: p.isDeduction,
        deductionId: p?.deductionId,
        deductionAmount: lineDeductionAmount,
      };
      paymentLine.push(payment);
    });

    deductionInvoice.map((p) => {
      let payment = {
        invoiceId: p.billId,
        loadId: p.loadId,
        loadNumber: p.loadNumber,
        deliveryDate: p.deliveryDate,
        paymentAmount: (this.convertNumber(p.paymentAmount) * -1).toFixed(2),
        invoiceAmount: Number(p.finalAmount * -1).toFixed(2),
        remainingAmount: Number(p.remainingAmount * -1).toFixed(2),
        lineItemId: p.invoiceLineItems ? p.invoiceLineItems[0]?.lineItemId : "",
        expense: p.expense ? p.expense : null,
        isDeduction: p.isDeduction,
        deductionId: p?.deductionId,
        deductionAmount: deductionAmount,
      };
      paymentLine.push(payment);
    });
    let driverPayment = {
      // driverId: this.searchForm.controls.driverId.value,
      // driverName: this.searchForm.controls.driver.value,
      paymentDate: this.searchForm.controls.date.value,
      paymentMethod: this.searchForm.controls.paymentMethod.value,
      bankAccount: this.searchForm.controls.bankAccount.value,
      paymentRef: this.searchForm.controls.paymentReference.value,
      amount: this.convertNumber(this.searchForm.controls.amount.value).toFixed(
        2
      ),
      paymentLine: paymentLine,
      isACH: this.isACH,
    };
    if (this.role === 'driver') {
      driverPayment['driverId'] = this.searchForm.controls.driverId.value != "" ? this.searchForm.controls.driverId.value : this.driverNameIdMap[this.searchForm.controls.driver.value];
      driverPayment['driverName'] = this.searchForm.controls.driver.value;
    } else if (this.role === 'carrier') {
      driverPayment['carrierId'] = this.searchForm.controls.carrierId.value != "" ? this.searchForm.controls.carrierId.value : this.carrierNameIdMap[this.searchForm.controls.carrier.value];
      driverPayment['carrierName'] = this.searchForm.controls.carrier.value;
    }
    this.loadingVisible = true;
    if (this.role === 'driver') {
      this._driverinvoiceservice.createDriverPayment(driverPayment).subscribe(
        (response) => {
          this.loadingVisible = false;
          console.log(response);
          if (response.Status == "error") {
            this._toaster.error("error", "Error", { timeOut: 4000 });
            this.loadingVisible = false;
          } else {
            // Update load by setting driverpayInvoiceStatus to completed if total amount is paid
            if (this.calculateTotalAmount(this.loadDetailsGrid) == this.convertNumber(this.searchForm.controls.amount.value)) {
              const loadId = this.selectedDriverInvoices[0]?.loadId;
              const load = this.loadDetailsGrid.find(load => load.loadId === loadId);
              load.driverpayInvoiceStatus = 'completed';
              delete load.loadId;
              delete load.driverId;
              delete load.driverName;
              delete load.loadNumber;
              delete load.loadDistance;
              delete load.calculatedAmount;
              delete load.payRate;
              delete load.payType;
              delete load.dispatcherPay;
              delete load.adjustedAmount;
              delete load.finalAmount;
              delete load.invoiceList;
              delete load.invoiceLineItems;
              delete load.invoiceStatus;
              delete load.deliveryAddress;
              delete load.isEdited;
              delete load.isDeduction;
              delete load.paymentAmount;
              delete load.billId;
              delete load.remainingAmount;
              delete load.isDwollaCustomer;
              delete load.dwollaCustomerId;
              delete load._id;
              this._loadservice.editLoadData(load, loadId).subscribe((data) => {
                console.log('Load updated', data);
              });
            }

            this._toaster.success("Save", "Success", { timeOut: 3000 });
            // this.router.navigateByUrl("/loadpay/payment-history");
            this.deductions = [];
            this.deductionsConst = [];
            this.paymentHistoryDeductions = [];
            this.loadDetailsGrid = [];
            this.paymentHistoryData = [];
            this.getData();
            this.getDeductionData();
            this.newItemEvent.emit();
          }
        },
        (error) => {
          this.loadingVisible = false;
          let resError = JSON.parse(error._body);
          this._toaster.error(resError.error, "Error", {
            timeOut: 5000,
          });
        }
      );
    } else if (this.role === 'carrier') {
      this._carrierinvoiceservice.createCarrierPayment(driverPayment).subscribe(
        (response) => {
          this.loadingVisible = false;
          console.log(response);
          if (response.Status == "error") {
            this._toaster.error("error", "Error", { timeOut: 4000 });
            this.loadingVisible = false;
          } else {
            // Update load by setting driverpayInvoiceStatus to completed if total amount is paid
            if (this.calculateTotalAmount(this.loadDetailsGrid) == this.convertNumber(this.searchForm.controls.amount.value)) {
              const loadId = this.selectedDriverInvoices[0]?.loadId;
              const load = this.loadDetailsGrid.find(load => load.loadId === loadId);
              load.driverpayInvoiceStatus = 'completed';
              delete load.loadId;
              delete load.driverId;
              delete load.driverName;
              delete load.loadNumber;
              delete load.loadDistance;
              delete load.calculatedAmount;
              delete load.payRate;
              delete load.payType;
              delete load.dispatcherPay;
              delete load.adjustedAmount;
              delete load.finalAmount;
              delete load.invoiceList;
              delete load.invoiceLineItems;
              delete load.invoiceStatus;
              delete load.deliveryAddress;
              delete load.isEdited;
              delete load.isDeduction;
              delete load.paymentAmount;
              delete load.billId;
              delete load.remainingAmount;
              delete load.isDwollaCustomer;
              delete load.dwollaCustomerId;
              delete load._id;
              this._loadservice.editLoadData(load, loadId).subscribe((data) => {
                console.log('Load updated', data);
              });
            }

            this._toaster.success("Save", "Success", { timeOut: 3000 });
            // this.router.navigateByUrl("/loadpay/payment-history");
            this.deductions = [];
            this.deductionsConst = [];
            this.paymentHistoryDeductions = [];
            this.loadDetailsGrid = [];
            this.paymentHistoryData = [];
            this.getData();
            this.getDeductionData();
            this.newItemEvent.emit();
          }
        },
        (error) => {
          this.loadingVisible = false;
          let resError = JSON.parse(error._body);
          this._toaster.error(resError.error, "Error", {
            timeOut: 5000,
          });
        }
      );
    }
  }
  getSelectedDriverInvoice() {
    this.selectedDriverInvoices = this.SearchedData.filter(
      (d) => d.isEdited == true
    );
  }
  onSelectedRole(event: any) {
    this.role = event.target.value;
    this.deductions = [];
    this.deductionsConst = [];
    this.paymentHistoryDeductions = [];
    this.loadDetailsGrid = [];
    this.paymentHistoryData = [];
    this.getData();
    this.getDeductionData();
  }
  onSelectedPaymentMethod(event) {
    console.log(event.target.value);
    if (event.target.value == "CASH") {
      this.searchForm.controls["bankAccount"].setValidators([
        Validators.required,
      ]);
      this.searchForm.controls["bankAccount"].disable();
      this.isCash = true;
    } else {
      this.searchForm.controls["bankAccount"].setValidators([
        Validators.required,
      ]);
      this.searchForm.controls["bankAccount"].enable();
      this.isCash = false;
    }
  }



  calculateTotalAmount(data: any[]) {
    const totalAmount = data?.reduce((acc, currentValue) => acc + Number(currentValue?.remainingAmount), 0);
    return totalAmount || 0;
  }

  calculateTotalBill(data: any[]) {
    const totalAmount = data?.reduce((acc, currentValue) => acc + Number(currentValue?.finalAmount), 0);
    return totalAmount || 0;
  }

  calculateTotalPaid(data: any[]) {
    const totalAmount = data?.reduce((acc, currentValue) => acc + Number((currentValue.amount || currentValue.finalAmount) - currentValue.remainingAmount), 0);
    return totalAmount || 0;
  }

  getCompantData() {
    this.companyService.getCompanyData().subscribe((data) => {
      this.companyData = data.result;
    });
  }
  viewInvoice(data) {
    console.log(data);
    let invoiceInfo = data;
    const company = this.companyData.find(
      (company) => company._id === localStorage.getItem("selectedCompany")
    );

    // let invoiceLineItems = data.invoiceItemDetails;

    invoiceInfo["companyName"] = company.name;
    invoiceInfo["companyAddress"] = company.address.fullAddress;
    let deductionInfo = this.paymentHistoryDeductions.filter(deduct => deduct._id == invoiceInfo._id);
    let deductionAmount = 0;
    if (deductionInfo.length > 0) {
      deductionAmount = deductionInfo.reduce((acc, currentValue) => acc + Number(currentValue.paymentAmount), 0);
    }
    let invoiceItemsData: any[][] = [
      [
        {
          text: "Load #",
          style: tableHeaderCustomStyle
        },
        {
          text: "Pay/Expense Type",
          style: tableHeaderCustomStyle
        },
        // {
        //   text: "Memo",
        //   style: tableHeaderCustomStyle
        // },
        {
          text: "Invoice Amount",
          style: tableHeaderCustomStyle,
          alignment: "right"
        },
        // {
        //   text: "Deduction Amount",
        //   alignment: "right",
        //   style: tableHeaderCustomStyle
        // },
        {
          text: "Remaining Amount",
          alignment: "right",
          style: tableHeaderCustomStyle
        },
        {
          text: "Paid Amount",
          alignment: "right",
          style: tableHeaderCustomStyle
        },
      ],
    ];

    invoiceInfo?.forEach((invoiceInfo: any) => {
      let columnsObj = [
        {
          text: invoiceInfo.loadNumber,
          border: [false, false, false, true],
          fillColor: "#fff",
          alignment: "left",
          margin: [0, 5, 0, 5],
        },
        {
          text: invoiceInfo?.isDeduction ? invoiceInfo?.expense?.Name : `${toPascalCase(this.role)} Pay`,
          alignment: "left",
          margin: [0, 5, 0, 5],
        },
        // {
        //   text: invoiceInfo.paymentRef == "" ? "-" : invoiceInfo.paymentRef,
        //   alignment: "left",
        //   margin: [0, 5, 0, 5],
        // },
        {
          text: getCurrency(invoiceInfo.amount || invoiceInfo.finalAmount),
          alignment: "right",
          margin: [0, 5, 0, 5],
        },
        // {
        //   text: getCurrency(invoiceInfo.deductionAmount || deductionAmount),
        //   alignment: "right",
        //   margin: [0, 5, 0, 5],
        // },
        {
          text: getCurrency(invoiceInfo.remainingAmount),
          alignment: "right",
          margin: [0, 5, 0, 5],
        },
        {
          text: getCurrency(invoiceInfo.paymentAmount || ((invoiceInfo.amount || invoiceInfo.finalAmount) - invoiceInfo.remainingAmount)),
          alignment: "right",
          margin: [0, 5, 0, 5],
        }
      ];
      invoiceItemsData.push(columnsObj);
    });
    // let deductionItemsData: any[][] = [];
    // if (deductionInfo.length > 0) {
    //   deductionItemsData = [
    //     [
    //       {
    //         text: "Load Number",
    //         fillColor: "#eaf2f5",
    //         border: [false, true, false, true],
    //         margin: [0, 5, 0, 5],
    //         textTransform: "uppercase",
    //       },
    //       {
    //         text: "Expense",
    //         border: [false, true, false, true],
    //         alignment: "left",
    //         fillColor: "#eaf2f5",
    //         margin: [0, 5, 0, 5],
    //         textTransform: "uppercase",
    //       },
    //       {
    //         text: "Invoice Amount",
    //         fillColor: "#eaf2f5",
    //         border: [false, true, false, true],
    //         alignment: "right",
    //         margin: [0, 5, 0, 5],
    //         textTransform: "uppercase",
    //       },
    //       {
    //         text: "Paid Amount",
    //         fillColor: "#eaf2f5",
    //         border: [false, true, false, true],
    //         alignment: "right",
    //         margin: [0, 5, 0, 5],
    //         textTransform: "uppercase",
    //       },
    //       {
    //         text: "Remaining Amount",
    //         fillColor: "#eaf2f5",
    //         border: [false, true, false, true],
    //         alignment: "right",
    //         margin: [0, 5, 0, 5],
    //         textTransform: "uppercase",
    //       },
    //     ],
    //   ];
    //   deductionInfo.forEach(p => {

    //     let columnsObj = [
    //       {
    //         text: p.loadNumber,
    //         border: [false, false, false, true],
    //         fillColor: "#fff",
    //         alignment: "left",
    //         margin: [0, 5, 0, 5],
    //       },
    //       {
    //         text: p.expense.Name,
    //         border: [false, false, false, true],
    //         fillColor: "#fff",
    //         alignment: "left",
    //         margin: [0, 5, 0, 5],
    //       },
    //       {
    //         text: getCurrency(p.amount || p.finalAmount),
    //         border: [false, false, false, true],
    //         fillColor: "#fff",
    //         alignment: "right",
    //         margin: [0, 5, 0, 5],
    //       },
    //       {
    //         text: getCurrency(p.paymentAmount),
    //         border: [false, false, false, true],
    //         fillColor: "#fff",
    //         alignment: "right",
    //         margin: [0, 5, 0, 5],
    //       },
    //       {
    //         text: getCurrency(p.remainingAmount),
    //         border: [false, false, false, true],
    //         fillColor: "#fff",
    //         alignment: "right",
    //         margin: [0, 5, 0, 5],
    //       },
    //     ];
    //     deductionItemsData.push(columnsObj);
    //   });
    // }
    let totalAmount = invoiceInfo.reduce((acc: number, currentValue: any) => acc + Number((currentValue.amount || currentValue.finalAmount) - currentValue.remainingAmount), 0);
    totalAmount = totalAmount + deductionAmount;
    console.log(invoiceInfo);
    console.log(invoiceItemsData);
    // this.generatePDF(invoiceInfo, invoiceItemsData, deductionItemsData, totatAmount);
    const pdfData = {
      invoiceHeader: invoiceInfo,
      invoiceItemsData: invoiceItemsData, // [...invoiceItemsData, ...deductionItemsData],
      widths: [40, "*", "*", "*", /*"*", "*",*/ 110],
      total: totalAmount
    }
    this._makePdfService.generatePaymentPDF(pdfData);
  }
}
